import { ADDBOOK, DELETE, LOADED, UPDATE } from "./actions";

export const bookLoaded = (value) => {
  return {
    type: LOADED,
    payload: value,
  };
};

export const addBook = (value) => {
  return {
    type: ADDBOOK,
    payload: value,
  };
};

export const update = (id, value) => {
  return {
    type: UPDATE,
    payload: {
      id,
      value,
    },
  };
};

export const deleted = (id) => {
  return {
    type: DELETE,
    payload: id
  };
};